import { render, staticRenderFns } from "./UserAvatarRow.vue?vue&type=template&id=68e9e16c&"
import script from "./UserAvatarRow.vue?vue&type=script&lang=js&"
export * from "./UserAvatarRow.vue?vue&type=script&lang=js&"
import style0 from "./UserAvatarRow.vue?vue&type=style&index=0&id=68e9e16c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports